import React from "react";
import { BC_HQ, PARTNERS } from "app_constants";
import { MenuIcon } from "components/icons/MenuIcon";
import { DateRangeSupport } from "helpers/shared/formatters/dates";

import type { ISectionProps } from "types/navigation";

const MENUS: ISectionProps = {
  feature: "Menus",
  icon: <MenuIcon />,
  path: "/menus",
  level: ["store", "brand"],
  dateSupport: DateRangeSupport.NONE,
  subSections: [
    {
      feature: "Your Menus",
      app: BC_HQ,
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/menus/menus",
      legacyPath: ({ searchParams }) =>
        searchParams && searchParams.has("id")
          ? `/menus/${searchParams.get("id")}`
          : "/menus",
      dateSupport: DateRangeSupport.NONE,
    },
    {
      feature: "New Menu",
      app: BC_HQ,
      hideInNav: true,
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/menus/new",
      legacyPath: () => `/menus/new`,
      dateSupport: DateRangeSupport.NONE,
    },
    {
      feature: "Items",
      app: BC_HQ,
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/menus/items",
      legacyPath: () => `/items`,
      dateSupport: DateRangeSupport.NONE,
    },
    {
      feature: "Display Groups",
      app: BC_HQ,
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/menus/display_groups",
      legacyPath: () => "/sections",
      dateSupport: DateRangeSupport.NONE,
    },
    {
      feature: "Modifiers",
      app: BC_HQ,
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/menus/modifiers",
      legacyPath: () => "/modifiers",
      dateSupport: DateRangeSupport.NONE,
    },
    {
      feature: "Modifier Groups",
      app: BC_HQ,
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/menus/modifier_groups",
      legacyPath: () => "/modifier_groups",
      dateSupport: DateRangeSupport.NONE,
    },
    {
      feature: "Categories",
      app: BC_HQ,
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/menus/categories",
      legacyPath: () => "/categories",
      dateSupport: DateRangeSupport.NONE,
    },
    {
      feature: "Courses",
      app: BC_HQ,
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/menus/courses",
      legacyPath: () => "/courses",
      dateSupport: DateRangeSupport.NONE,
    },
    {
      feature: "Your Reviews",
      app: PARTNERS,
      level: ["store"],
      scope: ["staff", "superuser"],
      path: "/menus/reviews",
      legacyPath: () => "/marketing/reviews",
      dateSupport: DateRangeSupport.NONE,
    },
  ],
};

export default MENUS;
